import React, { useEffect, useRef, useState } from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { Link } from 'react-router-dom';
import authApiService from '../services/authServices';
import playoffData from '../playoff.json';

// Renders player name - link only for 1ST ROUND, plain text for other levels
function PlayerNameLink({ player, seed, alignRight = false, plainText = false }) {
   const name = player?.display_name ?? player?.name ?? '';
   const userId = player?.userId ?? player?.user_id ?? player?.id;
   const actualSeed = player?.seed ?? seed;
   const seedEl = actualSeed != null ? <span className="player-text">{actualSeed}</span> : null;

   if (!name) return seedEl || null;
   const content = alignRight ? <>{name} {seedEl}</> : <>{seedEl} {name}</>;
   if (!plainText && userId) {
      return <Link to={`/carter/profile?userId=${userId}`} className="ie-post-link">{content}</Link>;
   }
   return content;
}

function Playoffs() {
   const [playoffsData, setPlayoffData] = useState([]);
   // Show a spinner until the bracket arrives instead of an empty bracket that fills in later.
   const [isLoading, setIsLoading] = useState(true);
   const latestRequest = useRef(0);
   const { left_bracket, right_bracket, finals } = playoffData.playoffs;

   useEffect(() => {
      fetchPlayoff();

      const handleSeasonChange = () => {
         fetchPlayoff();  // Re-fetch data when season changes
      };

      window.addEventListener("seasonChange", handleSeasonChange);

      return () => {
         window.removeEventListener("seasonChange", handleSeasonChange);
      };

   }, []);

   const fetchPlayoff = async () => {
      const requestId = ++latestRequest.current;
      setIsLoading(true);
      try {
         const selectedSeasonId = localStorage.getItem("selectedSeasonId");
         const response = await authApiService.get("playoff", { seasonId: selectedSeasonId });
         if (requestId !== latestRequest.current) return;
         if (response && response.bracket) {
            setPlayoffData(response?.bracket?.matches);
         }
      } catch (error) {
         console.error("Error fetching schedule data:", error);
      } finally {
         if (requestId === latestRequest.current) setIsLoading(false);
      }
   };

   console.log("playoffdata", playoffsData)

   const leftbracket = playoffsData?.left_bracket
   const rightbracket = playoffsData?.right_bracket
   const finalsData = playoffsData?.finals
   const champion = playoffsData?.champion


   return (
      <div className="page-container col-sm-9 playoffs-page">
         <div className="section">
            <div className="left">
            </div>
            <div className="right">
            </div>
         </div>
         {isLoading && (
            <div className="row">
               <div
                  className="col-12 playoffs-loading"
                  style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 320 }}
               >
                  <ThreeDots height="80" width="80" radius="9" color="#4fa94d" ariaLabel="three-dots-loading" visible={true} />
               </div>
            </div>
         )}
         <div className="row" style={isLoading ? { display: "none" } : undefined}>
            <div className="table-responsive mb-5">
               <table className="table table-borderless playoff-table table-sm">
                  <thead>
                     <tr className='play-head'>
                           <td style={{width:"14.28%"}}>1st Round</td>
                        <td style={{width:"14.28%"}}>Quarter Finals</td>
                        <td style={{width:"14.28%"}}>Semi Finals</td>
                        <td style={{width:"14.28%"}} className='text-center'>Finals</td>
                        <td style={{width:"14.28%"}} className='text-right'>Semi Finals</td>
                        <td style={{width:"14.28%"}} className='text-right'>Quarter Finals</td>
                        <td style={{width:"14.28%"}} className='text-right'>1st Round</td>
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td colSpan={7}>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[0]} seed={left_bracket.first_round[0].seed} /></td>
                        <td>&nbsp;</td>
                        <td></td>
                        <td rowSpan='3' className='text-center' style={{ verticalAlign: 'middle' }}><img width="50" className='mt-3' src="/images/trophy.png" alt="Cup" /> </td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[0]} seed={right_bracket.first_round[0].seed} alignRight /></td>
                     </tr>
                     <tr>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp; </td>
                        <td style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.quarter_finals[0]} plainText /></td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.quarter_finals[0]} alignRight plainText /></td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666', borderRight: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[1]} seed={left_bracket.first_round[1].seed} /></td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666', borderLeft: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[1]} seed={right_bracket.first_round[1].seed} alignRight /></td>
                     </tr>

                     <tr>
                        <td>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.semi_finals[0]} plainText /></td>
                        <td>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.semi_finals[0]} alignRight plainText /></td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[2]} seed={left_bracket.first_round[2].seed} /></td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[2]} seed={right_bracket.first_round[2].seed} alignRight /></td>
                     </tr>
                     <tr>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp; </td>
                        <td style={{ borderRight: '1px solid #666', borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.quarter_finals[1]} plainText /></td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td className='text-right' style={{ borderLeft: '1px solid #666', borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.quarter_finals[1]} alignRight plainText /></td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666', borderRight: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[3]} seed={left_bracket.first_round[3].seed} /></td>
                        <td>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td className='p-0' style={{ verticalAlign: 'top' }}><span style={{ borderBottom: '1px solid #666', padding: '6px .75rem', display: 'block', width: '80%' }}><PlayerNameLink player={finalsData?.finalists[0]} plainText /></span> </td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666', borderLeft: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[3]} seed={right_bracket.first_round[3].seed} alignRight /></td>
                     </tr>
                     <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[4]} seed={left_bracket.first_round[4].seed} /></td>
                        <td>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td className='p-0' style={{ verticalAlign: 'bottom' }}><span className='text-right float-right' style={{ borderBottom: '1px solid #666', padding: '6px .75rem', display: 'block', width: '80%' }}><PlayerNameLink player={finalsData?.finalists[1]} alignRight plainText /></span> </td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[4]} seed={right_bracket.first_round[4].seed} alignRight /></td>
                     </tr>
                     <tr>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp; </td>
                        <td style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.quarter_finals[2]} plainText /></td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.quarter_finals[2]} alignRight plainText /></td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666', borderRight: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[5]} seed={left_bracket.first_round[5].seed} /></td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666', borderLeft: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[5]} seed={right_bracket.first_round[5].seed} alignRight /></td>
                     </tr>

                     <tr>
                        <td>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td style={{ borderRight: '1px solid #666', borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.semi_finals[1]} plainText /></td>
                        <td>&nbsp;</td>
                        <td className='text-right' style={{ borderLeft: '1px solid #666', borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.semi_finals[1]} alignRight plainText /></td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[6]} seed={left_bracket.first_round[6].seed} /></td>
                        <td style={{ borderRight: '1px solid #666' }}>&nbsp;</td>
                        <td colSpan="3" rowSpan="3" className='text-center'>
                           <span className='champ-name'><PlayerNameLink player={champion?.championName} plainText /></span>
                           <span className='h5 text-center text-uppercase d-block mb-0' style={{ color: '#888888' }}>City Champion</span>
                        </td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[6]} seed={right_bracket.first_round[6].seed} alignRight /></td>
                     </tr>
                     <tr>
                        <td style={{ borderRight: '1px solid #666' }}> &nbsp;</td>
                        <td style={{ borderRight: '1px solid #666', borderBottom: '1px solid #666' }}><PlayerNameLink player={leftbracket?.quarter_finals[3]} plainText /></td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666', borderLeft: '1px solid #666' }}><PlayerNameLink player={rightbracket?.quarter_finals[3]} alignRight plainText /></td>
                        <td style={{ borderLeft: '1px solid #666' }}>&nbsp;</td>
                     </tr>
                     <tr>
                        <td className='pl-0' style={{ borderBottom: '1px solid #666', borderRight: '1px solid #666' }}><PlayerNameLink player={leftbracket?.first_round[7]} seed={left_bracket.first_round[7].seed} /></td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td className='text-right' style={{ borderBottom: '1px solid #666', borderLeft: '1px solid #666' }}><PlayerNameLink player={rightbracket?.first_round[7]} seed={right_bracket.first_round[7].seed} alignRight /></td>
                     </tr>
                     <tr>
                        <td colSpan={7}>&nbsp;</td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
   )
}

export default Playoffs
